export default __webpack_public_path__ + "static/11-497ace5d319f17d09671f32a21f60425.jpg";